// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2USS5","inputDescription":"styles_inputDescription__n4VGp"};